<template>
  <div style="padding: 0 24px">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
      <el-tab-pane v-for="item in comList" :key="item.name" :label="item.title" :name="item.name">
        <div style="border: 1px solid #E4E7ED;border-top: none; padding: 20px;border-radius: 0 0 6px 6px">
          <component :is="item.name" :name="item.name" :ref="item.name" v-if="activeName == item.name"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import returnGoods from "@/views/outOfDomestic/domesticShipment/returnGoods";
import transfer from "@/views/outOfDomestic/domesticShipment/transfer";
export default {
  name: "domesticShipment", // 国内发货
  components: {
    returnGoods,
    transfer
  },
  data() {
    return {
      activeName: returnGoods.name
    }
  },
  mounted() {
    // todo
    // this.$message.warning('开发中')
  },
  computed: {
    comList: function () {
      return [returnGoods, transfer]
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log('handleClick',tab, event,this);
      // this.$refs[tab.name][0].getTransfer();
    }
  }
}
</script>

<style scoped>
::v-deep .el-tabs__header{
  margin-bottom: 0px!important;
}
</style>